import styled from 'styled-components';

const TrainingListWrapper = styled.div`
  display: block;
`;

export { TrainingListWrapper };
